import type { SVGProps } from "react";
// generated from Business.svg — do not edit manually
// prettier-ignore
export default function Business(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M2 13V21H22V13M2 13V6H8M2 13H10M22 13V6H16M22 13H14M10 13V16H14V13M10 13H14M8 6V2H16V6M8 6H16" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
